module.exports = __webpack_public_path__ + "static/img/erweima.8ee3495.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/erweima.png
// module id = K86p
// module chunks = 1